import React, { Component } from 'react';
import { Button, Card, CardBody, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

export class Home extends Component {
  static displayName = Home.name;

  constructor(props) {
    super(props);
    this.state = {
      user: null
    };
  }

  componentDidMount() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        this.setState({ user });
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
  }

  render() {
    const { user } = this.state;

    return (
      <div className="home-page">
        {/* Hero Section */}
        <div className="welcome-banner text-center mb-5">
          <h1 style={{ fontSize: '2.8rem', marginBottom: '0.5rem' }}>
            Little Bear Coffee
          </h1>
          <p className="lead mb-4" style={{ fontSize: '1.2rem', maxWidth: '500px', margin: '0 auto' }}>
            Where every cup is made with love, just for you
          </p>

          {!user ? (
            <div className="mt-4">
              <Button color="primary" tag={Link} to="/login" size="lg" className="me-3">
                Sign In to Order
              </Button>
              <Button color="secondary" tag={Link} to="/register" size="lg">
                Create Account
              </Button>
            </div>
          ) : (
            <div className="mt-4">
              <p style={{ fontStyle: 'italic', color: '#6b8e6b' }}>
                Welcome back, {user.username}
              </p>
              <Button color="primary" tag={Link} to="/order" size="lg">
                Order Your Coffee
              </Button>
            </div>
          )}
        </div>

        {/* Features Section */}
        <Row className="mb-5">
          <Col md="4" className="mb-4">
            <Card className="h-100 text-center coffee-card">
              <CardBody>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
                  <span role="img" aria-label="coffee">&#x2615;</span>
                </div>
                <h4>Handcrafted</h4>
                <p className="text-muted">
                  Each drink is carefully prepared with attention to detail and quality ingredients.
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col md="4" className="mb-4">
            <Card className="h-100 text-center coffee-card">
              <CardBody>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
                  <span role="img" aria-label="leaf">&#x1F33F;</span>
                </div>
                <h4>Your Way</h4>
                <p className="text-muted">
                  Customize temperature, milk options, and more to match your perfect taste.
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col md="4" className="mb-4">
            <Card className="h-100 text-center coffee-card">
              <CardBody>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
                  <span role="img" aria-label="heart">&#x1F49A;</span>
                </div>
                <h4>Made with Love</h4>
                <p className="text-muted">
                  A personal touch in every cup, because you deserve something special.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Menu Preview */}
        <div className="text-center mb-5">
          <h2 className="mb-4">Explore Our Menu</h2>
          <p className="text-muted mb-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
            From classic espresso drinks to refreshing teas, we have something for everyone.
            Customize your drink just the way you like it.
          </p>
          {user ? (
            <Button color="primary" tag={Link} to="/order" outline>
              View Full Menu
            </Button>
          ) : (
            <Button color="primary" tag={Link} to="/login" outline>
              Sign In to See Menu
            </Button>
          )}
        </div>

        {/* How It Works */}
        <Card className="mb-5" style={{ background: 'linear-gradient(135deg, #f5f0e8 0%, #faf8f5 100%)' }}>
          <CardBody className="p-4">
            <h3 className="text-center mb-4">How It Works</h3>
            <Row>
              <Col md="3" className="text-center mb-3">
                <div className="rounded-circle d-inline-flex align-items-center justify-content-center"
                     style={{ width: '50px', height: '50px', background: '#6b8e6b', color: 'white', fontSize: '1.2rem', fontWeight: 'bold' }}>
                  1
                </div>
                <p className="mt-2 mb-0"><strong>Browse</strong></p>
                <small className="text-muted">Pick your drink</small>
              </Col>
              <Col md="3" className="text-center mb-3">
                <div className="rounded-circle d-inline-flex align-items-center justify-content-center"
                     style={{ width: '50px', height: '50px', background: '#6b8e6b', color: 'white', fontSize: '1.2rem', fontWeight: 'bold' }}>
                  2
                </div>
                <p className="mt-2 mb-0"><strong>Customize</strong></p>
                <small className="text-muted">Make it yours</small>
              </Col>
              <Col md="3" className="text-center mb-3">
                <div className="rounded-circle d-inline-flex align-items-center justify-content-center"
                     style={{ width: '50px', height: '50px', background: '#6b8e6b', color: 'white', fontSize: '1.2rem', fontWeight: 'bold' }}>
                  3
                </div>
                <p className="mt-2 mb-0"><strong>Order</strong></p>
                <small className="text-muted">Place your order</small>
              </Col>
              <Col md="3" className="text-center mb-3">
                <div className="rounded-circle d-inline-flex align-items-center justify-content-center"
                     style={{ width: '50px', height: '50px', background: '#6b8e6b', color: 'white', fontSize: '1.2rem', fontWeight: 'bold' }}>
                  4
                </div>
                <p className="mt-2 mb-0"><strong>Enjoy</strong></p>
                <small className="text-muted">Sip & smile</small>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Footer Note */}
        <div className="text-center" style={{ opacity: 0.7 }}>
          <p className="text-muted" style={{ fontStyle: 'italic' }}>
            A little something special, just between us
          </p>
        </div>
      </div>
    );
  }
}
